<template>
    <el-dialog :visible.sync="visible" :title="title" :close-on-click-modal="false" :close-on-press-escape="false" >
        <el-table :data="dataList" border  style="width: 100%;">
            <el-table-column prop="name" label="会员名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="mobile" label="会员手机" header-align="center" align="center"></el-table-column>
            <el-table-column prop="balanceTypeName" label="账号类型" header-align="center" align="center"></el-table-column>
            <el-table-column prop="balance" label="金额" header-align="center" align="center"></el-table-column>
            <el-table-column prop="operateTypeName" label="操作类型" header-align="center" align="center"></el-table-column>
            <el-table-column prop="status" label="状态" header-align="center" align="center"></el-table-column>
            <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        </el-table>
        <template slot="footer">
            <el-button @click="visible = false">关闭</el-button>
        </template>
    </el-dialog>
</template>
<script>
    export default {
        name: "order-lock-list",
        data() {
            return {
                visible: false,
                title:"查询订单冻结金额归属",
                dataForm: {
                    orderId:'',
                },
                dataList:[]
            }
        },
        methods: {
            init(orderId) {
                this.visible = true
                this.$nextTick(() => {
                    this.dataForm.orderId = orderId
                    this.getLockOrderId(orderId);
                })
            },
            getLockOrderId(orderId) {
                this.$http.get(`/oms/orderLock/getOrderLockListByOrderId/`+orderId).then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataList=res.data;
                }).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
